import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProductStepsComponent } from '../../../../components/product-steps/product-steps.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-about-us-business-grow',
    standalone: true,
    imports: [CommonModule, TranslateModule, RouterModule, SlickCarouselModule],
    templateUrl: './about-us-business-grow.component.html',
})
export class AboutUsBusinessGrowComponent {
    @ViewChild('productSteps') productSteps: ProductStepsComponent;

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        // prevArrow:
        //     '<button class="slick-prev"><img src="/assets/images/home/left-arrow.png" alt="Previous" /></button>',
        // nextArrow:
        //     '<button class="slick-next"><img src="/assets/images/home/right-arrow.png" alt="Next" /></button>',
    };

    scrollToJourney() {
        const element = document.querySelector('app-product-steps');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    scrollToFinancialAdvisory() {
        const element = document.querySelector('img[alt="Financial Advisory"]');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    scrollToGuide() {
        const element = document.querySelector(
            '.tw-flex.tw-items-center.tw-justify-center.tw-w-8.tw-h-8.tw-rounded-full.tw-border.tw-border-primary.tw-text-primary.tw-text-xl.tw-transition-transform.tw-duration-200'
        );
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
